/* src/app/webtree-website/insights-profile-section/insights-profile-section.component.scss */
.isActive {
  color: #2e93a1 !important;
}
.matrix {
  border-radius: 4px;
  width: 100%;
  border: solid 1px #d9d9d9;
  margin-right: 20px;
  padding: 6px 18px;
  background-color: #f2f2f2;
  display: flex;
  justify-content: center;
  align-items: center;
}
.matrix p {
  font-size: 12px;
  color: #484b59;
  margin-bottom: 0;
  margin-right: 10px;
  font-weight: normal;
}
.matrix span {
  font-size: 22px;
  font-weight: 600;
  display: flex;
  justify-content: center;
  align-items: center;
}
.matrix i {
  font-size: 14px;
}
.matrix span.min {
  font-size: 16px;
}
.matrix:last-child {
  margin-right: 0px;
}
.matrix:nth-child(2) p + span {
  display: flex;
  align-items: baseline;
}
.matrix:nth-child(2) p + span .median-tenure-text-size {
  font-size: 14px !important;
}
.matrix:nth-child(2) p + span .median-tenure-text-size:first-child {
  margin-right: 9px;
}
@media screen and (max-width: 912px) {
  .matrix {
    padding: 6px 6px;
  }
}
@media screen and (max-width: 912px) {
  .matrix {
    width: 24.5%;
    margin-right: 4px;
    margin-bottom: 0px;
    padding: 3px 6px;
  }
  .matrix p {
    font-size: 10px;
    margin-right: 3px;
  }
  .matrix span {
    font-size: 14px;
  }
  .matrix i {
    font-size: 9px;
  }
  .matrix span.min {
    font-size: 9px;
  }
  .matrix span.min .fa-person {
    display: none;
  }
  .matrix span.min .fa-person-dress {
    display: none;
  }
  .matrix:last-child {
    margin-right: 0px;
    margin-bottom: 0;
  }
  .matrix:nth-child(2) {
    margin-right: 4px;
  }
  .matrix:nth-child(2) p + span {
    display: flex;
    align-items: baseline;
  }
  .matrix:nth-child(2) p + span .median-tenure-text-size {
    font-size: 9px !important;
  }
  .matrix:nth-child(2) p + span .median-tenure-text-size:first-child {
    margin-right: 9px;
  }
  .matrix:nth-child(3) {
    margin-bottom: 0px;
  }
}
@media screen and (max-width: 1024px) {
  .matrix span.min .fa-person {
    display: none;
  }
  .matrix span.min .fa-person-dress {
    display: none;
  }
}
@media screen and (max-width: 768px) {
  .matrix {
    width: 49.3%;
    margin-right: 4px;
    margin-bottom: 5px;
    padding: 3px 6px;
  }
  .matrix p {
    font-size: 10px;
    margin-right: 3px;
  }
  .matrix span {
    font-size: 14px;
  }
  .matrix i {
    font-size: 9px;
  }
  .matrix span.min {
    font-size: 9px;
  }
  .matrix span.min .fa-person {
    display: none;
  }
  .matrix span.min .fa-person-dress {
    display: none;
  }
  .matrix:last-child {
    margin-right: 0px;
    margin-bottom: 0;
  }
  .matrix:nth-child(2) {
    margin-right: 0px;
  }
  .matrix:nth-child(2) p + span {
    display: flex;
    align-items: baseline;
  }
  .matrix:nth-child(2) p + span .median-tenure-text-size {
    font-size: 9px !important;
  }
  .matrix:nth-child(2) p + span .median-tenure-text-size:first-child {
    margin-right: 9px;
  }
  .matrix:nth-child(3) {
    margin-bottom: 0px;
  }
}
@media screen and (max-width: 640px) {
  .matrix {
    width: 49.3%;
    margin-right: 4px;
    margin-bottom: 5px;
    padding: 3px 6px;
  }
  .matrix p {
    font-size: 9px;
    margin-right: 3px;
  }
  .matrix span {
    font-size: 14px;
  }
  .matrix i {
    font-size: 9px;
  }
  .matrix span.min {
    font-size: 9px;
  }
  .matrix span.min .fa-person {
    display: none;
  }
  .matrix span.min .fa-person-dress {
    display: none;
  }
  .matrix:last-child {
    margin-right: 0px;
    margin-bottom: 0;
  }
  .matrix:nth-child(2) {
    margin-right: 0px;
  }
  .matrix:nth-child(2) p + span {
    display: flex;
    align-items: baseline;
  }
  .matrix:nth-child(2) p + span .median-tenure-text-size {
    font-size: 9px !important;
  }
  .matrix:nth-child(2) p + span .median-tenure-text-size:first-child {
    margin-right: 9px;
  }
  .matrix:nth-child(3) {
    margin-bottom: 0px;
  }
}
@media screen and (max-width: 480px) {
  .matrix {
    width: 49.3%;
    margin-right: 4px;
    margin-bottom: 5px;
    padding: 3px 6px;
  }
  .matrix p {
    font-size: 9px;
    margin-right: 3px;
  }
  .matrix span {
    font-size: 14px;
  }
  .matrix i {
    font-size: 9px;
  }
  .matrix span.min {
    font-size: 9px;
  }
  .matrix span.min .fa-person {
    display: none;
  }
  .matrix span.min .fa-person-dress {
    display: none;
  }
  .matrix:last-child {
    margin-right: 0px;
    margin-bottom: 0;
  }
  .matrix:nth-child(2) {
    margin-right: 0px;
  }
  .matrix:nth-child(2) p + span {
    display: flex;
    align-items: baseline;
  }
  .matrix:nth-child(2) p + span .median-tenure-text-size {
    font-size: 9px !important;
  }
  .matrix:nth-child(2) p + span .median-tenure-text-size:first-child {
    margin-right: 9px;
  }
  .matrix:nth-child(3) {
    margin-bottom: 0px;
  }
}
.report-text {
  border: 1px solid #d9d9d9;
  padding: 12px 16px;
  border-radius: 8px;
  width: 100%;
}
@media screen and (max-width: 912px) {
  .report-text {
    flex-wrap: wrap;
    padding: 10px 14px;
  }
}
@media screen and (max-width: 768px) {
  .report-text {
    flex-wrap: wrap;
    padding: 8px 12px;
  }
}
@media screen and (max-width: 640px) {
  .report-text {
    flex-wrap: wrap;
    padding: 4px 6px;
  }
}
@media screen and (max-width: 480px) {
  .report-text {
    flex-wrap: wrap;
    padding: 4px 6px;
  }
}
.insights-tab-container {
  width: 35%;
  margin: 0 auto;
}
.insights-tab-container .nav-pills {
  border-radius: 4px;
  width: 100%;
}
.insights-tab-container .nav-pills .nav-item {
  width: 50%;
}
.insights-tab-container .nav-pills .nav-item .nav-link {
  width: 100%;
  font-weight: 500;
  font-size: 14px;
  color: #969696;
  background-color: #ffffff;
  border: solid 1px #2e93a1;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.insights-tab-container .nav-pills .nav-item .nav-link.active {
  color: #2e93a1;
  border-right: solid 1px #2e93a1;
  background-color: #e4f1f3;
  font-size: 14px;
  font-weight: 500;
}
@media screen and (max-width: 912px) {
  .insights-tab-container {
    width: 50%;
  }
}
@media screen and (max-width: 768px) {
  .insights-tab-container {
    width: 60%;
  }
}
@media screen and (max-width: 640px) {
  .insights-tab-container {
    width: 80%;
  }
}
@media screen and (max-width: 480px) {
  .insights-tab-container {
    width: 100%;
  }
}
.btn-primary-light {
  padding: 7px 14px;
  border-radius: 3px;
  background-color: #e4f1f3;
  border: none;
  outline: none;
  color: #2e93a1;
  font-size: 14px;
}
.btn-gen-ai {
  padding: 7px 14px;
  border-radius: 3px;
  background-image:
    linear-gradient(
      253deg,
      #c845ab,
      #e24e7f);
  color: #ffffff;
  outline: none;
  border: 0;
  font-size: 14px;
  font-weight: normal;
}
.btn-filter {
  padding: 6px 14px;
  border-radius: 3px;
  background-color: #ffffff;
  border: 1px solid #2e93a1;
  outline: none;
  color: #2e93a1;
  font-size: 14px;
  -webkit-box-shadow: 0 0 5px 2px rgba(166, 223, 232, 0.5);
  -moz-box-shadow: 0 0 5px 2px rgba(166, 223, 232, 0.5);
  box-shadow: 0 0 5px 2px rgba(166, 223, 232, 0.5);
}
.btn-free-trial-yellow {
  padding: 7px 14px;
  border-radius: 3px;
  background-color: #ffeb37;
  border: none;
  outline: none;
  color: #484b59;
  font-size: 14px;
}
.btn-free-trial-yellow i {
  color: #2e93a1;
}
.btn-free-trial-primery {
  padding: 7px 14px;
  border-radius: 3px;
  background-color: #2e93a1;
  border: none;
  outline: none;
  color: #ffffff;
  font-size: 14px;
}
.btn-free-trial-primery i {
  color: #ffeb37;
}
.chips-container {
  width: calc(100% - 200px);
  display: flex;
  flex-wrap: wrap;
}
.chips-freemium {
  font-size: 14px;
  color: #484b59;
  border-radius: 21px;
  border: solid 1px #d9d9d9;
  padding: 5px 10px;
  display: flex;
  max-width: 200px;
  margin-right: 10px;
  margin-bottom: 10px;
  justify-content: center;
  align-items: center;
}
.chips-freemium i {
  color: #2e93a1;
  margin-left: 10px;
}
.spacer {
  height: 120px;
}
/*# sourceMappingURL=insights-profile-section.component-RE36C7WT.css.map */
